import LoadingStatus from '@libs/loading-status';

import {
  USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_FAILURE,
  USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_REQUEST,
  USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_SUCCESS,
} from '@app/store/actionTypes';
import { UserAuthorityAction } from '@app/store/user/authority/actions';

export type UserAuthorityPermissionsAndLimitsLoadingStatusState = LoadingStatus;

const initialState = LoadingStatus.IDLE;

export default function reducer(
  state: UserAuthorityPermissionsAndLimitsLoadingStatusState = initialState,
  action: UserAuthorityAction
) {
  switch (action.type) {
    case USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_REQUEST:
      return LoadingStatus.PENDING;
    case USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_SUCCESS:
      return LoadingStatus.SUCCEEDED;
    case USER_AUTHORITY__PERMISSIONS_AND_LIMITS_FETCH_FAILURE:
      return LoadingStatus.FAILED;
    default:
      return state;
  }
}
